import React, { useCallback } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeList } from 'react-window';

// Components
import Header from '../header';
import Search from './search';
import Arancel from './treatment';
import Modal from '../../../../../components/precios/modal'
import Tooltip from '../../../../../components/util/tooltip'

// Hooks
import useWidth from '../../../../../components/hooks/useWidth';
import useTratamientosAranceles from '../../hooks/useTratamientosAranceles'

const PreciosTratamientos = ({ item, onSelect }) => {
    const {
        text,
        modal,
        aranceles,
        moneda,
        tratamiento,
        onChangeText,
        onChangeMoneda,
        onSelectTratamiento,
        onCloseTratamiento
    } = useTratamientosAranceles(item);

    const width = useWidth();

    const getItemSize = useCallback((index) => {
        if(aranceles[index].EsTitulo) return 44;
        else if(width < 768){
            const length = aranceles[index].Tratamiento.length;
            if(length > 100){
                return 90;
            } else if(length > 90){
                return 85;
            } else if(length > 70){
                return 72;
            } else if(length > 50){
                return 60;
            } else if(length > 30){
                return 44;
            }
        }
        return 36;
    }, [ aranceles, width ])

    const onSelectBack = () => onSelect(null)
    return (
        <div className="flex grow column h-100">
            <div>
                <Header select={item} data={aranceles} onSelectBack={onSelectBack} />
                <Search text={text} onChangeText={onChangeText} />
            </div>
            <div className="flex grow column">
                <AutoSizer>
                    {({ height, width }) =>
                        <VariableSizeList 
                            height={height}
                            width={width}
                            itemCount={aranceles.length}
                            itemSize={getItemSize}
                        >
                            {({ index, style}) =>
                                <Arancel
                                    style={style}
                                    key={aranceles[index].idTratamiento}
                                    arancel={aranceles[index]}
                                    onSelect={onSelectTratamiento}
                                />
                            }
                        </VariableSizeList >
                    }
                </AutoSizer>
            </div>
            <div style={{ height: 1 }}>
                <Modal arancel={item} item={tratamiento} open={modal.open} moneda={moneda} onChangeMoneda={onChangeMoneda} onClose={onCloseTratamiento} />
                <Tooltip handleOpen={modal.handleOpen} title="Nuevo Arancel" color="primary" />
            </div>
        </div>
    );
}

export default PreciosTratamientos;